import React from "react";
import { useBrandLogo } from "@/lib/brand";

export const BrandLogoImg = ({ alt = "AMC Escolas", ...props }) => <img src={useBrandLogo()} alt={alt} {...props} />;
